export default __webpack_public_path__ + "static/media/ina_landscape.045edd92.JPG";